import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import FramePlayer from "image-sequence-player";
import image1 from "../../assets/img/cctv1.png";
import image2 from "../../assets/img/cctv2.png";
import image3 from "../../assets/img/cctv3.png";
import image4 from "../../assets/img/cctv4.png";
import image5 from "../../assets/img/cctv5.png";
import image6 from "../../assets/img/cctv6.png";
import { fetchVesselSearch, fetchVideoData } from "../../api/portal";

const reqSvgs = require.context("../../assets/2021-09-21", true, /\.jpg$/);
const paths = reqSvgs.keys();

const svgs = paths.map(path => reqSvgs(path));

// const videoFile = {
//   frames: svgs
// };

const APP = () => {
  const containerRef = useRef(null);
  const dataVideo = useSelector(state => state.videoData);
  const initialState = 1;
  const [numframe, setNumframe] = useState(initialState);

  let dataVid = [];

  useEffect(
    () => {
      let a = document.getElementById("parentnya");
      let aa = document.getElementById("my-player" + numframe);
      if (aa != null) {
        document.getElementById("my-player" + numframe).remove();
      }

      let g = document.createElement("div");

      let numfmarebaru = Math.floor(Math.random() * 10000);

      setNumframe(numfmarebaru);

      g.setAttribute("id", "my-player" + numfmarebaru);
      g.setAttribute("class", "frameplayer");

      a.appendChild(g);

      let videoFile1 = {
        frames: []
      };

      let videoFile = {
        frames: dataVideo
      };

      if (dataVideo.length > 0) {
        var options = {
          rate: 1,
          controls: true,
          autoplay: true,
          backwards: false,
          startFrame: 0,
          width: "100%",
          height: "600px",
          progressBarColor: "#f00"
        };
        //comment sementara wawan
        const player = new FramePlayer(
          "my-player" + numfmarebaru,
          options,
          videoFile
        );
        player.play();
      }
    },
    [dataVideo]
  );

  return (
    <div>
      <div id="parentnya">
        <div id="my-player" className="frameplayer" />
      </div>
    </div>
  );
};

export default APP;
